/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Alert;
Alert.$inject = ['$compile'];
function Alert($compile) {
    return {
        template: require('./alert.html'),
        restrict: 'E',
        require: ['^^hmyModal', 'hmyAlert'],
        controller: AlertController,
        controllerAs: 'vm',
        bindToController: true,
        link: function (scope, element, attrs, _a) {
            var parentCtrl = _a[0], vm = _a[1];
            parentCtrl.decorateChild(vm);
            parentCtrl.resolveReadyPromise(vm);
            vm.setHtmlContent = setHtmlContent;
            vm.setName('alert');
            function setHtmlContent(html) {
                vm.message = null;
                var compiled = $compile(html)(scope);
                var compiledContentHolder = element.find('.message > .compiled');
                compiledContentHolder.children().remove();
                compiledContentHolder.append(compiled);
                compiledContentHolder.find('a').on('click', function () {
                    vm.close(true);
                });
            }
        }
    };
}
var AlertController = (function () {
    function AlertController($element, $q, $log) {
        this.$element = $element;
        this.$q = $q;
        this.$log = $log;
        this.title = null;
        this.message = null;
        this.primaryActionLabel = 'OK';
        this.secondaryActionLabel = null;
        this.type = 'info';
        this.deferredPrimary = $q.defer();
        this.deferredSecondary = $q.defer();
        this.deferredDismissal = $q.defer();
    }
    AlertController.prototype.setTitle = function (title) {
        this.title = title;
    };
    AlertController.prototype.setMessage = function (message) {
        this.message = message;
    };
    AlertController.prototype.setHtmlContent = function (html) {
        this.$log.error("[alert.directive.controller] setHtmlContent(\"" + html + "\") should be implemented by the directive.");
    };
    AlertController.prototype.setPrimaryActionLabel = function (label) {
        this.primaryActionLabel = label;
    };
    AlertController.prototype.setSecondaryActionLabel = function (label) {
        this.secondaryActionLabel = label;
    };
    AlertController.prototype.setType = function (type) {
        this.type = type;
    };
    AlertController.prototype.onPrimary = function (callback) {
        return this.deferredPrimary.promise.then(callback);
    };
    AlertController.prototype.onSecondary = function (callback) {
        return this.deferredSecondary.promise.then(callback);
    };
    AlertController.prototype.primaryClick = function () {
        this.deferredPrimary.resolve();
        this.track('primary submit');
        this.close();
    };
    AlertController.prototype.secondaryClick = function () {
        this.deferredSecondary.resolve();
        this.track('secondary submit');
        this.close();
    };
    return AlertController;
}());
AlertController.$inject = ['$element', '$q', '$log'];



//////////////////
// WEBPACK FOOTER
// ./src/components/alert/alert.directive.ts
// module id = 6
// module chunks = 0